export default [
    "24 24",
    '<rect x="6.54688" y="6.54541" width="3.63642" height="3.63642" fill="var(--ci-primary-color, currentColor)" />\n' +
    '<rect x="10.1826" y="10.1816" width="3.63642" height="3.63642" fill="var(--ci-primary-color, currentColor)" />\n' +
    '<rect x="13.8193" y="10.1816" width="3.63642" height="3.63642" fill="var(--ci-primary-color, currentColor)" />\n' +
    '<rect x="13.8193" y="13.8184" width="3.63642" height="3.63642" fill="var(--ci-primary-color, currentColor)" />\n' +
    '<rect x="6.54688" y="13.8184" width="3.63642" height="3.63642" fill="var(--ci-primary-color, currentColor)" />\n' +
    '<rect x="3" y="3" width="18" height="18" rx="3" class="stroke-over" stroke="var(--ci-primary-color, currentColor)" fill="none" stroke-width="2"/>']

